import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-client-stores',
  templateUrl: './client-stores.component.html',
  styleUrls: ['./client-stores.component.scss']
})
export class ClientStoresComponent implements OnInit {

  @Input() merchant;
  @Input() stores;
  @Output() saved = new EventEmitter;

  public loading = true;

  constructor() { }

  ngOnInit() {
    this.stores = this.merchant.stores;
    this.loading = false;
  }

  selectStore(store) {
    this.saved.emit(store);
  }

}
